import api from "./api";

const VendorStoreService = {
  create: async (data) => {
    const res = await api.post("/vendorStore/save", data);
    return res.data;
  },

  getAll: async (page = 1, limit = 20, search = "") => {
    const res = await api.get(
      `/vendorStore/getAll?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
    );
    return res.data;
  },

  getActive: async () => {
    const res = await api.get("/vendorStore/getActive");
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/vendorStore/getById/${id}`);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/vendorStore/update/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/vendorStore/delete/${id}`);
    return res.data;
  },

  updateStatus: async (id) => {
    const res = await api.put(`/vendorStore/updateStatus/${id}`);
    return res.data;
  },

  getByVendor: async (vendorId) => {
    const res = await api.get(`/vendorStore/getByVendor/${vendorId}`);
    return res.data;
  },
};

export default VendorStoreService;
